<template>
  <b-modal ref="fileModal" v-model="showModal" title="Anexar Arquivo">
    <div class="dropzone-container" @dragover="dragover" @dragleave="dragleave" @drop="drop" :style="isDragging && 'border-color: green'">
      <input type="file" name="file" id="fileInput" class="hidden-input" @change="onChange" ref="file" accept=".pdf,.jpg,.jpeg,.png,.gif,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.ods,.mp3,.ogg,.mp4,.avi,.txt,.zip,.rar" hidden="true" />
      <label for="fileInput" class="file-label">
        <div v-if="isDragging">Solte o arquivo!</div>
        <div v-else>Arraste o arquivo aqui ou <u>Clique aqui</u> para o subir o arquivo.</div>
      </label>
      <div class="preview-container mt-4" v-if="file">
        <div class="preview-card">
          <div>
            <p>{{ file.name }}</p>
          </div>
          <div>
            <button class="ml-2" type="button" @click="remove" title="Remove file">
              <b>×</b>
            </button>
          </div>
        </div>
      </div>
    </div>
    <template #modal-footer>
      <div class="w-100 text-right">
        <button type="button" class="btn btn-third btn-sm" @click="handleFileUpload" v-b-tooltip.hover title="Enviar">
          <i class="fas fa-check-circle"></i><span class="d-md-down-none">Enviar</span>
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'FileModal',
  data () {
    return {
      showModal: false,
      isDragging: false,
      file: null
    }
  },
  props: {
    reply: {
      type: Object,
      required: false,
      default: null
    }
  },
  methods: {
    show () {
      this.showModal = true
    },
    onChange () {
      this.file = this.$refs.file.files[0]
    },
    dragover (e) {
      e.preventDefault()
      this.isDragging = true
    },
    dragleave () {
      this.isDragging = false
    },
    drop (e) {
      e.preventDefault()
      this.file = e.dataTransfer.files[0]
      this.isDragging = false
    },
    remove () {
      this.file = null
      this.$refs.file.value = null
    },
    handleFileUpload () {
      if (!this.file) return

      const reader = new FileReader()
      reader.readAsDataURL(this.file)
      reader.onload = () => {
        const fileInfo = {
          fileName: this.file.name,
          mimeType: this.file.type,
          fileBase: reader.result.split('base64,')[1],
          quotedMsg: this.getQuotedMsg()
        }
        const extension = this.getExtensionFromMimeType(this.file.type)
        if (extension === 'pdf' || extension === 'doc' || extension === 'docx' || extension === 'xls' || extension === 'xlsx' || extension === 'ppt' || extension === 'pptx' || extension === 'ods' || extension === 'zip' || extension === 'rar') {
          fileInfo.type = 'document'
          this.sendArchive(fileInfo)
        } else if (extension === 'jpg' || extension === 'jpeg' || extension === 'png' || extension === 'gif') {
          fileInfo.type = 'image'
          this.sendArchive(fileInfo)
        } else if (extension === 'mp3' || extension === 'ogg') {
          fileInfo.type = 'audio'
          this.sendAudio(fileInfo)
        } else if (extension === 'mp4' || extension === 'avi') {
          fileInfo.type = 'video'
          this.sendArchive(fileInfo)
        }
        this.file = null
        this.showModal = false
      }
      reader.onerror = (error) => {
        console.error('Error reading file:', error)
      }
    },
    getExtensionFromMimeType (mimeType) {
      const mimeTypes = {
        'application/pdf': 'pdf',
        'application/msword': 'doc',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
        'application/vnd.ms-excel': 'xls',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
        'application/vnd.ms-powerpoint': 'ppt',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
        'application/vnd.oasis.opendocument.spreadsheet': 'ods',
        'image/jpeg': 'jpg',
        'image/png': 'png',
        'image/gif': 'gif',
        'audio/mpeg': 'mp3',
        'audio/ogg': 'ogg',
        'video/mp4': 'mp4',
        'video/x-msvideo': 'avi',
        'text/plain': 'txt',
        'application/zip': 'zip',
        'application/x-rar-compressed': 'rar'
      }
      return mimeTypes[mimeType] || 'bin'
    },
    getQuotedMsg () {
      if (this.reply && this.reply.message) {
        return this.reply.message.messageId
      }
      return null
    },
    sendArchive (fileInfo) {
      this.$emit('sendFile', fileInfo)
    },
    sendImage (fileInfo) {
      this.$emit('sendImage', fileInfo)
    },
    sendAudio (fileInfo) {
      this.$emit('sendAudio', fileInfo)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/modal/FileModal.vue